import { Link } from "react-router";
import IconShoppingCart from "@/assets/icons/shopping-cart.svg?react";
import IconChevronRight from "@/assets/icons/chevron-right.svg?react";
import Image from "@/components/base/Image.tsx";
import type { Partner } from "../api";

interface PartnerCardProps {
  partner: Partner;
}

export default function PartnerCard({ partner }: PartnerCardProps) {
  return (
    <Link
      to={`/partners/${partner.id}`}
      className="block rounded-xl border-b border-white/[0.04] bg-gray-4 transition-all duration-200 active:scale-[0.985] active:bg-white/[0.04]"
    >
      <div className="p-2 flex items-center gap-3">
        <div className="w-12 h-12 rounded-xl bg-white/08 flex-center overflow-hidden shrink-0">
          {partner.icon ? (
            <Image
              urls={partner.icon}
              size="tiny"
              imgClassName="object-cover w-12 h-12"
              wrapperClassName="rounded-xl"
              alt={partner.name}
            />
          ) : (
            <IconShoppingCart className="size-6 text-orange-100" />
          )}
        </div>

        {/* Info */}
        <div className="flex-1 min-w-0">
          <p className="text-[15px] font-semibold text-white leading-130 truncate">
            {partner.name}
          </p>
          {partner.description && (
            <p className="text-xs text-gray-1 leading-140 mt-0.5 line-clamp-1">
              {partner.description}
            </p>
          )}
        </div>

        {/* Chevron */}
        <IconChevronRight className="size-6 text-gray-1 shrink-0" />
      </div>
    </Link>
  );
}
